/* eslint-disable no-restricted-globals */
import { Culture } from "@core/Culture";
import { isSafariBrowser } from "./Util";

let pageInterval: NodeJS.Timeout;
let pageObject: Window | null;

export interface IFeatures {
    width?: number;
    height?: number;
    resizable?: number;
}


export const redirectToPage = (url: string, callBack: any, title?: string, features?: IFeatures) => {
    clearInterval(pageInterval);
    pageObject = createWindow(`${window.location.origin}/${Culture.getLocale().lang}${url}`, title, features);
    pageInterval = setInterval(() => {
        if (pageObject?.closed) {
            clearInterval(pageInterval);
            callBack(title);
        }
    }, 1000);
}

export function createWindow(url?: string, target?: string, features?: IFeatures) {
    const w = features?.width || 938;
    const h = features?.height || 596;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
    return window.open(url, target, `width=${w},height=${h},top=${top},left=${left},resizable=${features?.resizable}`);
}

export function print(windowPrint: Window, content: string) {
    windowPrint?.document.write("<html><head><title>" + document.title + "</title>");
    windowPrint?.document.write("</head><body>");
    windowPrint?.document.write(content);
    windowPrint?.document.write("</body></html>");
    windowPrint?.document.close(); // necessary for IE >= 10
    windowPrint?.focus(); // necessary for IE >= 10*/
    windowPrint?.print();
    windowPrint?.close();
}

export function getPrint(title?: string) {
    if (title)
        document.title = title;
    // Print for Safari browser
    if (isSafariBrowser())
        document.execCommand('print', false, undefined);
    else
        window.print();
}